import type { Translate } from "@client-app/i18n";

type ConnectionMeta = {
  connectedAt: string;
  connectedBy: string;
};

export const formatConnectionTimestamp = (locale: string, connectedAt: string) => {
  if (!connectedAt || connectedAt === "Recent") {
    return null;
  }

  const parsedDate = new Date(connectedAt);
  if (Number.isNaN(parsedDate.getTime())) {
    return connectedAt;
  }

  const includesExplicitTime = connectedAt.includes("T") || /\d:\d{2}/.test(connectedAt);
  return new Intl.DateTimeFormat(
    locale === "zh-CN" ? "zh-CN" : "en-US",
    includesExplicitTime
      ? {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: false,
        }
      : {
          month: "short",
          day: "numeric",
          year: "numeric",
        },
  ).format(parsedDate);
};

export const formatConnectionMetaLine = (t: Translate, locale: string, connection: ConnectionMeta) => {
  const formattedTimestamp = formatConnectionTimestamp(locale, connection.connectedAt);

  if (!formattedTimestamp) {
    return connection.connectedBy
      ? t("website.integrationsSettings.connectedRecentlyBy", {
          user: connection.connectedBy,
        })
      : t("website.integrationsSettings.connectedRecently");
  }

  return connection.connectedBy
    ? t("website.integrationsSettings.connectedByOn", {
        user: connection.connectedBy,
        date: formattedTimestamp,
      })
    : t("website.integrationsSettings.connectedOn", {
        date: formattedTimestamp,
      });
};
